import { Component, OnInit } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular'

@Component({
  selector: 'app-activity-log-OLD',
  templateUrl: './activity-log.page.html',
  styleUrls: ['./activity-log.page.scss'],
})
export class ActivityLogPage implements OnInit {

  constructor(private modalController : ModalController) { }

  ngOnInit() {
  }

  async dismissModal() {
    await this.modalController.dismiss()
}

}
